import { MenuItem, withStyles } from "@material-ui/core";

import * as colors from "../../../theme/colors";

export const StyledMenuItem = withStyles({
  root: {
    color: colors.darkBlue900,
    fontSize: 16,
    fontWeight: 700,
    height: 65,
    minWidth: 185,
    display: "flex",
    justifyContent: "left",
    textTransform: "uppercase",
    background: colors.lightBlue,
    "&:hover": {
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: colors.darkBlue900,
      },
      background: colors.lightBlue,
      color: colors.darkThemeGreen,
    },
  },
})(MenuItem);
